import { Engine } from '@babylonjs/core/Engines/engine'
import type { AbstractEngine } from '@babylonjs/core/Engines/abstractEngine'

export type RenderingBackend = 'webgl2' | 'webgpu'

export interface EngineResult {
  readonly engine: AbstractEngine
  readonly backend: RenderingBackend
}

export async function createEngine(canvas: HTMLCanvasElement): Promise<EngineResult> {
  if (!navigator.webdriver && 'gpu' in navigator) {
    try {
      const { WebGPUEngine } = await import('@babylonjs/core/Engines/webgpuEngine')
      if (await WebGPUEngine.IsSupportedAsync) {
        const engine = new WebGPUEngine(canvas, { antialias: true, adaptToDeviceRatio: false })
        await engine.initAsync()
        return { engine, backend: 'webgpu' }
      }
    } catch {
      // WebGL2 is the compatibility baseline and handles any WebGPU initialization failure.
    }
  }
  const engine = new Engine(canvas, true, {
    alpha: false,
    antialias: true,
    preserveDrawingBuffer: false,
    stencil: true,
    disableWebGL2Support: false,
    adaptToDeviceRatio: false,
  })
  return { engine, backend: 'webgl2' }
}
